import slug from 'constants/slug'
import createBreadcrumb from 'shared/breadcrumb/hoc'
//import Icon from 'themes/icon'

export default createBreadcrumb({
  list: {
    id: 'list',
    //icon: Icon.car,
    href: slug.license.list,
    name: 'License'
  }
})



// WEBPACK FOOTER //
// ./src/containers/license/breadcrumb.js